import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Vuex from "vuex";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "@/language/vi.js";
import i18n from "@/language/i18n.js";
import FlagIcon from "vue-flag-icon";
locale.el.pagination.pagesize = "";
import moment from "moment";
import lodash from "lodash";
import {funcCommon} from '@/utils/functionCommon.js'
import {funcData} from '@/utils/DataCommon.js'
import {styleExcel} from '@/utils/styleExcel.js'
// Import plugin bạn vừa tạo
import VueBrowserDetect from "@/plugins/VueBrowserDetect";
// import numeral from "numeral";
import VueCurrencyInput from "vue-currency-input";
import ElCurrencyInput from "@/components/ElCurrencyInput.vue";
import SpinnerCustom from "@/components/SpinnerCustom.vue";
import DialogBase from "@/components/DialogBase.vue";
import UploadExcelComponent from "@/views/import-export/UploadExcel.vue";
// import browserDetect from "vue-browser-detect-plugin"

import store from "./store";
import "@/assets/style/CommonStyle.css";
Vue.config.productionTip = false;
Vue.use(ElementUI, { locale });
Vue.use(Vuex);
Vue.use(FlagIcon);
// Vue.use(browserDetect);
// Đăng ký plugin
Vue.use(VueBrowserDetect);
Vue.component("ElCurrencyInput", ElCurrencyInput);
Vue.component("SpinnerCustom", SpinnerCustom);
Vue.component("DialogBase", DialogBase);
Vue.component("UploadExcel", UploadExcelComponent);
const formatCurrency = {
  globalOptions: { currency: "VND", locale: "de", allowNegative: false },
};
Vue.use(VueCurrencyInput, formatCurrency);

Vue.filter("formatDate", function(value) {
  if (value) {
    return moment(String(value)).format("DD/MM/YYYY");
  }
});
Vue.filter("formatTime", function(value) {
  if (value) {
    return moment(String(value), "HHmm").format("HH:mm");
  }
});
Vue.filter("formatDateTime", function(value) {
  if (value) {
    return moment(String(value)).format("HH:mm - DD/MM/YYYY");
  }
});
Vue.filter("formatDayMonth", function(value) {
  if (value) {
    return moment(String(value)).format("DD/MM");
  }
});
//format cũ chỉ cho trường hợp có giá trị khác 0
Vue.filter("formatCurrency", function(value) {
  if (value) {
    const formattedValue = new Intl.NumberFormat("de", {
      style: "currency",
      currency: "VND",
    }).format(Math.abs(value));

    return value < 0 ? `(${formattedValue})` : formattedValue;
  }
});

//format cho trường hợp giá trị bằng 0 và khác 0
Vue.filter("formatCurrencyNew", function(value) {
  if (value) {
    return new Intl.NumberFormat("de", {
      style: "currency",
      currency: "VND",
    }).format(value);
  }else{
    return 0;
  }
});
//format cho số cách nhau với hàng nghìn
Vue.filter("formatNumber", function(number) {
  if (number || number === 0) {
    return new Intl.NumberFormat("vi-VN").format(number);
  }
  return 0;
});


new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");

//set file js
Vue.prototype.loda = lodash;
Vue.prototype.moment = moment;
//global variable for application
Vue.prototype.$pageLayoutDefault = "sizes, prev, pager, next";
Vue.prototype.$pageListDefault = [10, 25, 50, 10000];
Vue.prototype.$pageListDefaultNew = [10, 25, 50, 100];
Vue.prototype.$pageListDefaultNewOneAdmin = [25, 50, 100, 300, 500, 1000];
Vue.prototype.$pageListDefaultCardOneAdmin = [50, 100, 200, 300, 500, 1000, 2000, 3000, 5000];
Vue.prototype.$pageListDefaultUser = [25, 50, 100, 500, 1000];
Vue.prototype.$pageSizeDefault = 10000;
Vue.prototype.$pageSizeDefaultNew = 25;
Vue.prototype.$pageTotalDefault = 10;

Vue.prototype.$tableMaxHeightMini = 400;
Vue.prototype.$tableMaxHeightSmallMini = 450;
Vue.prototype.$tableMaxHeightSmall = 500;
Vue.prototype.$tableMaxHeight = 700;
Vue.prototype.$tableMaxHeightCardManager = 700;
Vue.prototype.$tableMaxHeightRow = 150;
Vue.prototype.$tableLoading = "Đang tải dữ liệu, vui lòng chờ...";
Vue.prototype.$tableEmpty = "Không có dữ liệu!!!";
Vue.prototype.$permissionDenied = "Bạn không có quyền thực hiện chức năng này";

//các hàm xử lý chung ở js
Vue.prototype.$funcCommon = funcCommon;
Vue.prototype.$funcData = funcData;
Vue.prototype.$styleExcel = styleExcel;

